import { ChevronLeft } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

/**
 * The one page-header back control: a bordered square with a chevron and no
 * text. Where it leads is named only in the tooltip and the accessible label,
 * so every page header carries the same small control instead of a mix of
 * arrows, chevrons and labelled links.
 */
interface BackButtonProps {
	/** Tooltip and accessible name, e.g. "Back to Workflows". */
	label: string;
	/** Route to go back to. Use `onClick` instead when the way back is state. */
	to?: string;
	onClick?: () => void;
	/** Layout-only extras (margins); the look itself is fixed here. */
	className?: string;
}

const BASE_CLASS =
	"inline-flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white text-[#3f4247] hover:bg-gray-50";

const BackButton: React.FC<BackButtonProps> = ({
	label,
	to,
	onClick,
	className,
}) => {
	const classes = className ? `${BASE_CLASS} ${className}` : BASE_CLASS;
	const icon = <ChevronLeft className="h-4 w-4" aria-hidden />;
	if (to !== undefined) {
		return (
			<Link to={to} aria-label={label} title={label} className={classes} onClick={onClick}>
				{icon}
			</Link>
		);
	}
	return (
		<button type="button" aria-label={label} title={label} className={classes} onClick={onClick}>
			{icon}
		</button>
	);
};

export default BackButton;
